import { resolvePendingOp } from './asteriskAsyncOp';

/**
 * Cria um handler de ActionCable para os eventos `asterisk.<resource>.changed`.
 *
 * Payload esperado (vide app/jobs/asterisk/broadcasts_changes.rb):
 *   { account_id: <id>,
 *     event_type: 'created'|'updated'|'deleted'|'published',
 *     resource:   'extension'|'did'|'queue'|'trunk'|'ivr'|'ivr_flow',
 *     id:         <identificador alvo, opcional>,
 *     status:     'success'|'error',
 *     error:      <mensagem quando status='error'> }
 *
 * Estratégia:
 *   1. Resolve/rejeita a Promise pendente criada pelo store action
 *      (correlação por resource+eventType+id) — quem cria toast é o
 *      `toast.promise()` do form via vue-sonner.
 *   2. Em success, dispatcha `fetch` pra reagar lista (cache do Rails foi
 *      invalidado pelo job, GET puxa estado fresco).
 *
 * @param {string} fetchActionName - nome da action que refaz a lista (default 'fetch').
 * @param {string} resource        - rótulo do resource pra correlacionar com a
 *                                   promise pendente (ex: 'extension').
 */
export const createHandleRealtimeEvent =
  (fetchActionName = 'fetch', resource = '') =>
  ({ dispatch }, payload = {}) => {
    const { status, error, event_type: eventType, id } = payload;

    if (resource) {
      resolvePendingOp(resource, eventType, id, status, error);
    }

    if (status === 'success') {
      dispatch(fetchActionName);
    }
  };
